export default function () {
    const FontList = ['Light', 'Normal', 'Regular', 'Medium', 'Demibold', 'Semibold', 'Bold', 'Heavy'];
    for (let i = 0; i < FontList.length; i++) {
        // ?subsets这个参数加上会扫描页面中的所有文字，然后打包相关的字体文件
        import(`@/assets/fonts/MiSans-${FontList[i]}.ttf?subsets`).then(res => {
            console.log(res.css.family);

        });
    }
    // 设置默认字体
    // document.body.style.fontFamily =
    //     '"MiSans Demibold","PingFangSC-Semibold fallback default 6578a6","PingFangSC-Regular fallback default 6578a6","Microsoft YaHei fallback default 6578a6","Source Han Sans fallback default 6578a6"';
}
